exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a9b6a49e] .el-dialog__body{max-height:650px;overflow:auto}\n", ""]);

// exports
